import {
  ApplePayMerchantCapabilities,
  ApplePaySupportedNetworks,
  GooglePayAuthMethods,
  GooglePayCardNetworks,
} from '@/common/models/groups'
import { Countries } from '@/core/constants/countries'

export const PAYMENT_PROVIDERS_OPTIONS = [
  { value: 'BT_IPAY', label: 'Bank Transfer' },
  { value: 'STRIPE', label: 'Stripe' },
  { value: 'EU_PLATESC', label: 'EU Platesc' },
  { value: 'CRYPTO_PULSAR', label: 'Pulsar' },
]

export const COUNTRY_CODE_OPTIONS = Object.values(
  Countries.reduce<Record<string, { value: string; label: string }>>(
    (acc, c) => {
      acc[c.countryCode] = {
        value: c.countryCode,
        label: `${c.countryNameEn} (${c.countryCode})`,
      }
      return acc
    },
    {},
  ),
)

export const SUPPORTED_NETWORKS = Object.values(ApplePaySupportedNetworks).map(
  (v) => ({ value: v, label: v }),
)

export const MERCHANT_CAPABILITIES = Object.values(
  ApplePayMerchantCapabilities,
).map((v) => ({ value: v, label: v }))

export const CARD_NETWORKS = Object.values(GooglePayCardNetworks).map((v) => ({
  value: v,
  label: v,
}))

export const CONFIG_AUTH_METHODS = Object.values(GooglePayAuthMethods).map(
  (v) => ({ value: v, label: v }),
)
